import React, { useMemo } from 'react';
import { FocusOn } from 'react-focus-on';
import clsx from 'clsx';
import { List } from '../list';
import { Portal } from '../portal';
import { MenuProvider } from './menu-context';
import { useMenu } from './use-menu';
import styles from './styles.module.css';
/**
 * `<Menu />` — Элемент интерфейса, позволяющий реализовать выпадающие списки.
 * Использует в своей основе компонент `<List>`.
 * @example ``` tsx
 <Menu button={<MenuButton />} >
 <ListItem value="1" text="Вариант 1" />
 <ListItem value="2" text="Вариант 2" />
 <ListItem value="3" text="Вариант 3" />
 </Menu>
 * ```
 */
export const Menu = props => {
  const {
    focusOnAttributes,
    menuContextAttributes,
    popoverAttributes,
    portalAttributes,
    listAttributes,
    open,
    mounted
  } = useMenu(props);
  const {
    className,
    header,
    onScroll
  } = props;
  const popoverClassName = useMemo(() => clsx(styles.popover, {
    [styles.openPopover]: open
  }, className), [open, className]);
  return /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(MenuProvider, {
    ...menuContextAttributes
  }), mounted && (/*#__PURE__*/React.createElement(Portal, {
    ...portalAttributes
  }, /*#__PURE__*/React.createElement(FocusOn, {
    ...focusOnAttributes
  }, /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    "data-testid": "menu-popover",
    className: popoverClassName,
    onScroll: onScroll,
    ...popoverAttributes
  }, header, /*#__PURE__*/React.createElement(List, {
    ...listAttributes
  }))))));
};